import { FC } from 'react';
import { IFeatureProps } from 'mod/featureV2/interface';
import { IFeatureParallax } from 'mod/featureV2/interface/parallax';
import { FeatureContainer } from 'mod/featureV2/FeatureContainer';
import { Parallax } from './Parallax';
import { validFeature } from 'mod/featureV2/FeatureParallax/utils';

type IProps = IFeatureProps<IFeatureParallax>

export const FeatureParallax: FC<IProps> = props => {
    let { feature } = props;
    feature = validFeature(feature);

    return feature.config.medias.length === 0 ? null : (
        <FeatureContainer {...props} feature={feature}>
            <Parallax {...feature}/>
        </FeatureContainer>
    )
};

export default FeatureParallax;
